__turbopack_context__.v({
  "blok-big-title": "styles-module__7mhKMq__blok-big-title",
  "blok-subtitle": "styles-module__7mhKMq__blok-subtitle",
  "blok-title": "styles-module__7mhKMq__blok-title",
  "indicator": "styles-module__7mhKMq__indicator",
  "trigger": "styles-module__7mhKMq__trigger",
  "wrapper": "styles-module__7mhKMq__wrapper",
});
